import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';

const CompetitionOtherConditionEditDialog = (props) => {
    const [competition, setCompetition] = useState(null);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setCompetition({ ...props?.value, otherCondition: props?.value?.otherCondition || '' });
    }, [props.value]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: competition,
        validate: (data) => {
            let errors = {};

            // if(!data.otherCondition || data.otherCondition.trim() === '') {
            //     errors.otherCondition = translatedMessage('form.error.competition.otherCondition.required');
            // }

            return errors;
        },
        onSubmit: (data) => {
            // console.log(data);
            saveCompetition(data);
        }
    });

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const saveCompetition = (data) => {
        competitionService.saveCompetitionJob(data)
            .then((savedTest) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedTest, true);
                }
                hideDialog();
                formik.resetForm();
            })
            .catch((error) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(null, false, error);
                }
            });
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="otherCondition-form" type="submit" />
        </>
    );

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.visible}
                header={translatedMessage('competition.requirements.otherCondition.info')}
                modal
                className="pcn-dialog p-fluid"
                footer={dialogFooter}
                onHide={hideDialog}
            >
                <form id="otherCondition-form" onSubmit={formik.handleSubmit}>
                    <div className="field p-inputgroup">
                        <span className="p-float-label">
                            <InputTextarea type="text" id="otherCondition" name="otherCondition" value={formik.values?.otherCondition}
                                onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('otherCondition') })}
                                rows={5} cols={30} autoResize
                                maxLength={10000}
                                tooltip={translatedMessage("field.character.maxLength", "10.000")}
                                tooltipOptions={{ position: 'top' }} />
                            <label htmlFor="otherCondition" className={classNames({ 'p-error': isFormFieldValid('otherCondition') })}>
                                {translatedMessage("competition.requirements.otherCondition.info")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('otherCondition')}


                </form>
            </Dialog>
        </>
    );
};

export default CompetitionOtherConditionEditDialog;
